import React, { useState } from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ErrorBox } from '../components/ui';
export default function Login() {
  const { login, user } = useAuth();
  const nav = useNavigate(); const loc = useLocation();
  const [u, setU] = useState(''); const [p, setP] = useState('');
  const [err, setErr] = useState(null); const [busy, setBusy] = useState(false);
  if (user) return <Navigate to={loc.state?.from?.pathname || '/'} replace />;
  const submit = async e => {
    e.preventDefault(); setBusy(true); setErr(null);
    try { await login(u, p); nav(loc.state?.from?.pathname || '/', { replace: true }); }
    catch (e2) { setErr(e2); setBusy(false); }
  };
  return <div className="login-page"><form className="login-card" onSubmit={submit}>
    <h1>Building Safety Programme Tracker</h1>
    <p className="muted" style={{marginTop:0,marginBottom:18}}>Sign in to continue</p>
    <ErrorBox error={err} />
    <div className="field"><label>Username</label><input style={{width:'100%'}} value={u} onChange={e=>setU(e.target.value)} autoFocus/></div>
    <div className="field"><label>Password</label><input type="password" style={{width:'100%'}} value={p} onChange={e=>setP(e.target.value)}/></div>
    <button className="primary" style={{width:'100%'}} disabled={busy}>{busy?'Signing in…':'Sign in'}</button>
    <p className="muted" style={{marginBottom:0,marginTop:14}}>Demo: admin / pmanager / viewer — password Admin@123</p>
  </form></div>;
}
